import { z } from 'zod'

/**
 * Validation schema for creating/editing offers
 */
export const offerFormSchema = z.object({
    titleEn: z.string().min(1, 'English title is required').max(200, 'Title must be less than 200 characters'),
    type: z.enum(['flash', 'bundle', 'club'], {
        required_error: 'Offer type is required',
    }),
    expiryDate: z.string().optional(),
    lineItems: z
        .array(
            z.object({
                productId: z.string(),
                productName: z.string(),
                variantId: z.string(),
                variantName: z.string(),
                imageUrl: z.string().nullable(),
                priceId: z.string().min(1, 'Price is required'),
                quantity: z.number().int().min(1, 'Quantity must be at least 1'),
            }),
        )
        .min(1, 'At least one product is required'),
    promotionIds: z.array(z.string()).optional(),
})

export type OfferFormData = z.infer<typeof offerFormSchema>

